const INSTANT_STORAGE_HOSTS = new Set([
	"files.instantdb.com",
	"instant-storage.s3.amazonaws.com",
]);

export function isInstantStorageUrl(value: string): boolean {
	try {
		return INSTANT_STORAGE_HOSTS.has(new URL(value).hostname);
	} catch {
		return false;
	}
}

/**
 * Extract file ID from an InstantDB storage URL.
 * URL format: https://files.instantdb.com/{app_id}/{num}/{file_id}?...
 * Legacy URL format: https://instant-storage.s3.amazonaws.com/{app_id}/{num}/{file_id}?...
 */
export function extractFileIdFromUrl(url: string): string | null {
	try {
		const urlObj = new URL(url);
		if (!INSTANT_STORAGE_HOSTS.has(urlObj.hostname)) {
			return null;
		}
		const pathParts = urlObj.pathname.split("/").filter(Boolean);
		if (pathParts.length >= 3) {
			return pathParts[pathParts.length - 1];
		}
		return null;
	} catch {
		return null;
	}
}
